import React from 'react';

//component
import ModalWrapper from  '@/components/modals/ModalWrapper';
import SimpleSearchInput from  '@/components/elements/search/simpleSearchInput';
import NotificationBar from  '@/components/elements/languages/NotificationBar';
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable';
import { BasicBreadcrumbs, BasicButton, CancelConfirmPanel, LoadingSpinner } from 'thrive-components';

//component hook
import UseContentModal from './ContentModal.hooks';

//styling
import '../../../../css/modals/widgetContentModal.scss'



const ContentModal = ({setShowModal, isDuplicateContent}:{setShowModal:any, isDuplicateContent?: boolean}) => {
    const {
        modalTitle,
        confirmButtonClicked,
        confirmButtonText,
        confirmButtonLabel,
        searchString,
        breadcrumbs,
        tableData,
        showBreadcrumbs,
        showBackButton,
        selectedContentId,
        notificationDetails,
        textInputDisabled,
        onBackButtonClick,
        setSearchString,
        onConfirmClick,
    } = UseContentModal({setShowModal, isDuplicateContent});

    return (
        <>
        <ModalWrapper
            className="widget-content-modal" 
            isOpen={true} 
            escClose={true} 
            onRequestClose={() => setShowModal(false)}
        >           
            <h1 className='widget-content-modal-header'>
                {modalTitle}
            </h1>

            <SimpleSearchInput 
                className="widget-content-modal-search-input"
                ariaLabel={'Search for a content item'} 
                setSearchString={setSearchString} 
                searchString={searchString} 
                isDisabled={textInputDisabled}           
            />

            {showBreadcrumbs &&
                <BasicBreadcrumbs 
                    breadCrumbs={breadcrumbs}
                />
            }

            <SimpleTable
                {...tableData}
                isInfiniteScroll
                isDragAndDrop={false}
                isPaginated={false}
                hideActionsColumn
            />

            {showBackButton &&
                <BasicButton 
                    content={"Back"}
                    className='cancel-button-style widget-content-modal-back-button'
                    onButtonClick={onBackButtonClick} 
                    ariaLabel={'Back to previous list'}                
                />
            }

            <CancelConfirmPanel 
                cancelContent={'Cancel'} 
                confirmContent={confirmButtonClicked ? <LoadingSpinner size={5} /> : confirmButtonText} 
                ariaLabelCancel={'Cancel'} 
                ariaLabelConfirm={confirmButtonLabel}
                panelClassName={'widget-content-modal-cancel-confirm-panel'} 
                confirmIsDisabled={!selectedContentId || confirmButtonClicked} 
                onCancelClick={()=>setShowModal(false)} 
                onConfirmClick={onConfirmClick}
            />
        </ModalWrapper>  
        
        <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails?.status} msg={notificationDetails.message} />
        </>
    )

}
    
export default ContentModal

